import { render, staticRenderFns } from "./MaterialPublishList.vue?vue&type=template&id=ca373292&scoped=true"
import script from "./MaterialPublishList.vue?vue&type=script&lang=js"
export * from "./MaterialPublishList.vue?vue&type=script&lang=js"
import style0 from "./MaterialPublishList.vue?vue&type=style&index=0&id=ca373292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca373292",
  null
  
)

export default component.exports